export default "__VITE_ASSET__6$c6kf1I__"